import React from "react";
import styled from "styled-components";
import GradientInputField from "./GradientInputField";

export const DefaultContainer = ({ onSend, setUserText }) => {
  const [isMultiline, setIsMultiline] = React.useState(false); // Add
  const BubbleItems = [
    { id: 1, text: "Guide me to Create a Module" },
    { id: 2, text: "Create modules for Biktarvy in Spain market" },
  ];
  const listBoxItems = [
    {
      items: [
        "Select the relevant eDetail.",
        "Choose one or more slides from the selected eDetail.",
        "Review the slide-to-module mapping and select the elements to be used for module creation.",
        "Review/Edit the module metadata and generate modules.",
      ],
    },
  ];

  const handleBubbleMsg = (elem) => {
    onSend(elem);
  };
  return (
    <>
      <MainContainer>
        <MainText>Hey! I am your Module Agent</MainText>
        <MaintwoText>
          I can help you create a module in just 4 steps:
        </MaintwoText>
        <OneContainer>
          {listBoxItems.map((box, boxIndex) => (
            <BoxContent key={boxIndex}>
              <OrderedList>
                {box.items.map((text, index) => (
                  <ListItem key={index}>{text}</ListItem>
                ))}
              </OrderedList>
            </BoxContent>
          ))}
        </OneContainer>
        <InputContainer>
          <GradientInputField
            isMultiline={isMultiline}
            setIsMultiline={setIsMultiline}
            onSend={onSend}
            setUserText={setUserText}
          />
        </InputContainer>
        <BubblesCont $ismultiline={isMultiline}>
          {BubbleItems.map((ele) => {
            return (
              <Bubbles
                onClick={() => {
                  handleBubbleMsg(ele.text);
                }}
                key={ele.id}
              >
                {" "}
                {ele.text}
              </Bubbles>
            );
          })}
        </BubblesCont>
      </MainContainer>
    </>
  );
};

const MainContainer = styled.section`
  background: #f5f5f7;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 169px);
  flex-direction: column;
`;

const MainText = styled.div`
  font-size: 32px;
  font-weight: 700;
`;

const MaintwoText = styled.span`
  width: 26.2rem;
  text-align: center;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  margin-top: 6px;
`;

const OneContainer = styled.div`
  width: 713px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  justify-content: center;
  align-items: center;
`;

const BoxContent = styled.div`
  height: auto;
  width: 648px;
  border-radius: 12px;
  padding: 16px;
  background: #ffffff;
  color: #54565b;
  font-size: 14px;
  font-weight: 400;
`;

// Changed from CustomList to OrderedList using ol
const OrderedList = styled.ol`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const ListItem = styled.li`
  color: #54565b;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
`;

const InputContainer = styled.div`
  width: 713px;
  height: 60px;
  margin-top: 40px;
  // margin-bottom: 11px;
`;

const BubblesCont = styled.article`
  width: 486px;
  margin-top: ${({ $ismultiline }) => ($ismultiline ? "22px" : "11px")};
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const Bubbles = styled.article`
  height: 48px;
  background: #9c6fff14;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #1e1e1e;
  font-weight: 700;
  width: auto;
`;
